import React from 'react';
import PropTypes from 'prop-types';
import { expand } from './util';
import styles from './Expander.css';
import iconPlusCircle from '../../images/icon_plus_circle.png';

const Expander = ({
  children,
  expanders,
  setExpander,
  headerTemplate,
  id,
  isOpen = false,
  autoAdjust
}) => (
  <tbody id={`expander_${id}`}>
    <tr
      id={`header_${id}`}
      className="fund-row-expander"
      data-name="rowExpander"
      onClick={() => expand(id, expanders, setExpander, autoAdjust)}>
      <th colSpan="1" className="header">
        <img
          className={`icon-plus-circle ${isOpen ? 'collapse' : 'expand'}`}
          alt={`${isOpen ? 'Click to collapse' : 'Click to expand'}`}
          src={iconPlusCircle}
        />
      </th>
      <th colSpan="99" scope="colgroup">
        <button type="button" className="header-template">
          {headerTemplate}
        </button>
      </th>
    </tr>
    {isOpen && children}
    <style jsx>{styles}</style>
  </tbody>
);

Expander.propTypes = {
  expand: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isOpen: PropTypes.bool
};

export default Expander;
